import { axios } from "src/common/utils";
import { appSettings } from "src/configs";
import { commonHeader, authHeader } from "src/common/requestHeader";
const ConfigService = {};

ConfigService.getConfigSystem = (formData) => {
    return new Promise((resolve, reject) => {
        axios({
            headers: {
                ...commonHeader(),
                ...authHeader(),
            },
            method: "get",
            url: `${appSettings.services.map.apiUrl}/api/v1.0/config`,
            params: { ...formData }
        })
            .then((response) => resolve(response))
            .catch((error) => reject(error));
    });
};

ConfigService.updateConfigSystem = (formData) => {
    return new Promise((resolve, reject) => {
        axios({
            headers: {
                ...commonHeader(),
                ...authHeader(),
            },
            method: "post",
            url: `${appSettings.services.map.apiUrl}/api/v1.0/Config`,
            data: formData
        })
            .then((response) => resolve(response.data))
            .catch((error) => reject(error));
    });
};

export default ConfigService;